import { Card } from "antd";
import { t } from "i18next";
import { useEffect } from "react";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import { DataGridProvider } from "../../core/components/data-grid/DataGridContext";
import AppConfig from "../../core/service/AppConfig";
import SmsLogDataGrid from "./SmsLogDataGrid";
import SmsLogFilter from "./SmsLogFilter";

export default function SmsLogApp() {
    useEffect(() => {
        document.title = `${t('SMS Logs')} - ${AppConfig.getHisTitle()}`
    }, []);

    return (
        <SimpleLayout fullWidth={true}>
            <Card title={t('SMS Logs')}>
                <DataGridProvider>
                    <SmsLogFilter />
                    <SmsLogDataGrid />
                </DataGridProvider>
            </Card>
        </SimpleLayout>
    )
}
